type SupportedLanguagesType = [
    'da',
    'de',
    'en-au',
    'en-ca',
    'en-in',
    'en-us',
    'en',
    'es-mx',
    'es',
    'fi',
    'fr-ca',
    'fr',
    'hi',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt-pt',
    'pt',
    'ru',
    'sv',
    'zh-Hant',
    'zh'
];

export const supportedLanguages: SupportedLanguagesType = [
    'da',
    'de',
    'en-au',
    'en-ca',
    'en-in',
    'en-us',
    'en',
    'es-mx',
    'es',
    'fi',
    'fr-ca',
    'fr',
    'hi',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt-pt',
    'pt',
    'ru',
    'sv',
    'zh-Hant',
    'zh',
];
